import { createSlice } from '@reduxjs/toolkit'

const updatedOnSlice = createSlice({
  name: 'LeadUpdatedOn',
  initialState: null, // Initial value of updatedOn
  reducers: {
    setLeadUpdatedOn: (state, action) => action.payload
  }
})

export const { setLeadUpdatedOn } = updatedOnSlice.actions

export default updatedOnSlice.reducer
